/**
 * API COVERAGE — TenantsController (/api/tenants) [provisioning key]
 *   POST /api/tenants → tenantsApi.provision  (requires X-Provisioning-Key header)
 */
import { request } from '@/lib/apiClient';
import type { RegisterTenantRequest, RegisterTenantResult } from '@/types/auth';

// Control-plane tenant provisioning: POST /api/tenants.
// [AllowAnonymous] but gated by the X-Provisioning-Key header (matched against
// Provisioning:ApiKey on the server). Use only from a trusted admin/ops tool — never ship
// the provisioning key in a public bundle.
export const tenantsApi = {
  provision: (body: RegisterTenantRequest, provisioningKey: string) =>
    request<RegisterTenantResult>({
      method: 'POST',
      url: '/tenants',
      data: body,
      headers: { 'X-Provisioning-Key': provisioningKey },
    }),
};
